import { useEffect, useState } from "react";
import { FaPlus } from "react-icons/fa6";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEdit } from "@fortawesome/free-solid-svg-icons";
import { TableLoader } from "../../../Common/ShimmerLoader";
import MUITable from "../../../Common/MUITable";
import isGHMC from "../../../Common/helper/helpar";
import { ExportGrievanceCategory } from "./ExportGrievanceCategory";
import AddEditGrievanceForm from "./AddEditGrievanceForm";
import { useGrievanceCategoryStore } from "./GrievanceCategoryStore/useGrievanceCategoryStore";
import { StatusBadge } from "../../Rfid/utils/statusBadge";

const GrievanceCategoryRootComponent = () => {
  const isProd = isGHMC();
  const [showModal, setShowModal] = useState(false);
  const [editRow, setEditRow] = useState(null);
  const [isEditMode, setIsEditMode] = useState(false);

  const {
    filteredGrievanceCategories,
    isLoading,
    filters,
    pagination,
    fetchGrievanceCategories,
    fetchSlaCategoryTypeOptions,
    searchGrievanceCategoryHandler,
  } = useGrievanceCategoryStore();

  useEffect(() => {
    fetchGrievanceCategories();
    fetchSlaCategoryTypeOptions();
  }, [fetchGrievanceCategories, fetchSlaCategoryTypeOptions]);

  const handleSearchChange = (event) => {
    searchGrievanceCategoryHandler(event.target.value);
  };

  const handlePageChange = (_event, newPage) => {
    fetchGrievanceCategories({
      currentPage: newPage + 1,
    });
  };

  const handleRowsPerPageChange = (event) => {
    const nextPageSize = parseInt(event.target.value, 10);
    fetchGrievanceCategories({
      currentPage: 1,
      pageSize: nextPageSize,
    });
  };

  const handleEdit = (row) => {
    setIsEditMode(true);
    setEditRow(row);
    setShowModal(true);
  };

  const handleAdd = () => {
    setIsEditMode(false);
    setEditRow(null);
    setShowModal(true);
  };

  const grievanceCategoryColumns = [
    {
      label: "Category Name",
      field: "categoryName",
    },
    {
      label: "SLA Category Type",
      field: "slaCategoryType",
    },
    {
      label: "Status",
      render: (row) => <StatusBadge isActive={row.isActive} compact />,
    },
    {
      label: "Actions",
      render: (row) => (
        <button
          type="button"
          className={isProd ? "edit-ghmc" : "edit-swm"}
          onClick={() => handleEdit(row)}
          aria-label={`Edit ${row.categoryName}`}
        >
          <FontAwesomeIcon icon={faEdit} />
        </button>
      ),
    },
  ];

  return (
    <>
      <div className="content text-start">
        <div className="page-content">
          <div className="d-flex justify-content-between align-items-start flex-wrap gap-3 mt-3">
            <div>
              <h5 className="mb-1 fw-semibold">Grievance Category Information</h5>
             
            </div>
            <div className="d-flex align-items-center flex-wrap">
              <button type="button" className="button-container" onClick={handleAdd}>
                <FaPlus className="font-size-20 me-1" /> Add Grievance Category
              </button>
              <ExportGrievanceCategory
                grievanceCategoryData={filteredGrievanceCategories}
              />
            </div>
          </div>

          <div className="card shadow mt-3">
            <div className="card-body">
              <div className="row align-items-end">
                <div className="col-md-3 mb-3">
                  
                  <input
                    type="text"
                    name="searchTerm"
                    value={filters.searchTerm}
                    onChange={handleSearchChange}
                    placeholder="Search Category Name"
                    className="form-control bg-white"
                  />
                </div>
              </div>

              <div>
                <MUITable loading={isLoading}
                  needSRNumber
                  rows={filteredGrievanceCategories}
                  columns={grievanceCategoryColumns}
                  serverPagination
                  totalCount={pagination.totalCount}
                  page={Math.max(0, pagination.currentPage - 1)}
                  rowsPerPage={pagination.pageSize}
                  onPageChange={handlePageChange}
                  onRowsPerPageChange={handleRowsPerPageChange}
                  rowsPerPageOptions={[5, 10, 25, 50]}
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      <AddEditGrievanceForm
        showModal={showModal}
        setShowModal={setShowModal}
        editRow={editRow}
        isEditMode={isEditMode}
      />
    </>
  );
};

export default GrievanceCategoryRootComponent;
